import { CognitoIdentityClient } from '@aws-sdk/client-cognito-identity'
import { fromCognitoIdentityPool } from '@aws-sdk/credential-provider-cognito-identity'
import { Polly } from '@aws-sdk/client-polly'
import { getSynthesizeSpeechUrl } from '@aws-sdk/polly-request-presigner'
//Parser
const parser = new DOMParser()
// Set the parameters
const speechParams: any = {
  OutputFormat: 'mp3',
  SampleRate: '24000',
  Text: '',
  TextType: 'ssml', // Still using SSML
  VoiceId: 'Ruth', // ✅ Changed voice to Ruth
  Engine: 'neural'
}

const client = new Polly({
  region: `us-east-1`,
  credentials: fromCognitoIdentityPool({
    client: new CognitoIdentityClient({
      region: `us-east-1`
    }),
    identityPoolId: `us-east-1:${process.env.REACT_APP_AWS_POOL_ID}` // IDENTITY_POOL_ID
  })
})

const speakText = async (text: string, isMath: boolean = false) => {
  const numberPattern = /\d/
  const numberPatternTest = numberPattern.test(text)

  // Parse HTML and get plain text
  let plainText =
    parser.parseFromString(text, 'text/html').body.textContent || ''

  if (numberPatternTest && isMath) {
    const pattern = /[-\d\s]+/
    const res = pattern.test(plainText)

    const pattern2 = /-/g
    const res2 = pattern2.test(plainText)

    if (res && res2) {
      plainText = plainText.replace(/-/g, 'minus')
    }

    const pattern3 = /[–\d\s]+/
    const res3 = pattern3.test(plainText)

    const pattern4 = /–/g
    const res4 = pattern4.test(plainText)

    if (res3 && res4) {
      plainText = plainText.replace(/–/g, 'minus')
    }
  }

  // Handle punctuation marks with SSML - convert periods and question marks
  // plainText = plainText
  //   .replace(
  //     /\./g,
  //     '<break time="300ms"/> <sub alias=" ">.</sub> <break time="400ms"/>'
  //   )
  //   // .replace(/,/g, '<break time="200ms"/> <sub alias="comma">,</sub> <break time="200ms"/>')
  //   .replace(
  //     /\?/g,
  //     '<break time="300ms"/> <sub alias=" ">?</sub> <break time="400ms"/>'
  //   );

  plainText = plainText
    // Replace only when period/question mark is at end of sentence (before space or end)
    .replace(/\.([ \n]|$)/g, '.<break time="150ms"/>$1')
    .replace(/\?([ \n]|$)/g, '?<break time="150ms"/>$1')

  // Wrap the text in SSML speak tags
  speechParams.Text = `<speak>${plainText}</speak>`

  console.log(speechParams.Text, 'speechParams.Text')

  try {
    let url = await getSynthesizeSpeechUrl({
      client,
      params: speechParams
    })

    return url
  } catch (err) {
    console.error('Error', err)
    return ''
  }
}

export default speakText
